import React, { useState } from "react";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddSubCategory from "../../Modals/addSubCategory";

const ManageSubCategories = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);

  // Parent category name for display
  const parentCategory = "Car";

  // Sample sub-categories for this parent category
  const subCategories = [
    { id: 1, name: "Family Cars", createdDate: "01-Sept-2025", status: true },
    { id: 2, name: "Sports Cars", createdDate: "02-Sept-2025", status: true },
    { id: 3, name: "Luxury Cars", createdDate: "03-Sept-2025", status: false },
  ];

  const handleCloseModal = () => setOpenModal(false);

  return (
    <>
      {/* PAGE TITLE */}
      <div className="main_title">
        <h1><span className="c_primary">{parentCategory}</span> : Sub-Categories</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-categories")}>Categories Management</button> –{" "}
          Sub-Categories Management
        </p>
      </div>

      <div className="cards">
        {/* TABLE HEADER */}
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder={`Search Sub-Categories of ${parentCategory}...`}
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add Sub-Category
            </Button>
          </div>
        </div>

        {/* SUB-CATEGORIES TABLE */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Sub-Category Name</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Enable/Disable</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {subCategories.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <div className="user_block">
                      <figure className="no_radius">
                        <img src="/static/images/placeholder.png" alt={row.name} />
                      </figure>
                      <p>
                        <b>{row.name}</b>
                      </p>
                    </div>
                  </TableCell>

                  <TableCell>{row.createdDate}</TableCell>

                  <TableCell>
                    <SwitchToggle defaultChecked={row.status} />
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </IconButton>
                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* ADD / EDIT SUB-CATEGORY MODAL */}
      <AddSubCategory
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageSubCategories;